import MessageLogModel from "./MessageLogModel";
import ValidationItemModel from "./ValidationItemModel";

export default class OddClientValidationModel extends ValidationItemModel {
  name: any = { validation: null, message: new MessageLogModel() };
  credentials: any = { validation: null, message: new MessageLogModel() };
}
